<template>
  <div id="viaducto">
    <div class="border-top">
      <div class="col-md-7 pr-0 container-rightR" :style="{'background-image': 'url(' + require('../assets/img/bgViaducto.png') + ')'}"></div>
      <div class="container-fluid header-content">
        <div class="row ">
          <div class="col-md-6 container-left">
            <p>
              <img :src='"../assets/img/viaductoS.png"' class="img-fluid mb-3">
            </p>

            <div class="mt-5">
              <p>
                <b class="txt-prim title2">Módulo de Transparencia</b>
              </p>
              <p>
                El  módulo  de  transparencia  del <b> Viaducto  Elevado  Bicentenario  (VB)</b> tiene  por objetivo  ser  una  fuente  de  consulta  accesible  a  toda  persona  y  organización  que quiera conocer sobre nuestra historia, funcionamiento y entorno.
              </p>
              <p>
                En  este sitio se  encuentran las características físicas del <b>VB</b>, así como datos relevantes, desde  la  licitación  pública  hasta la  última  modificación  al  título  de Concesión, financiamientos obtenidos, y valores que rigen a nuestro equipo.
              </p>
              <p>
                Asimismo,  hemos incluido las  principales  acciones  de  construcción, explotación, operación, conservación y mantenimiento del <b>VB</b>, mismas que realizamos aplicando nuestros pilares  de  seguridad,  servicio  al  cliente  y  trabajo  en  equipo  para  mantener la carretera  en  condiciones  óptimas  y seguras  para  nuestros  usuarios  y  cumplir cabalmente con las obligaciones que le fueron conferidas a la concesionaria del <b>VB</b>  mediante el título de concesión.
              </p>
              <p>
                En el <b>VB</b> la sostenibilidad y la transparencia son pilares que rigen nuestras acciones y  decisiones,  por  lo cual, mediante este sitio también  buscamos  comunicar  los proyectos para contribuir con el desarrollo de nuestro equipo, las comunidades y el medio  ambiente  donde  operamos,  así  como con las  iniciativas  para  mantener  la transparencia y el buen gobierno de la concesión.
              </p>
              <p>
                Finalmente,  en  este sitio usted  podrá  consultar  nuestro  título  de  concesión e información de soporte (anexos y modificaciones).
              </p>
            </div>

          </div>
          <div class="col-md-6 pr-0 container-right" :style="{'background-image': 'url(' + require('../assets/img/bgViaducto.png') + ')'}"></div>
        </div>
        <div class="container-left pt-0">
          <div class="row">
            <div class="col-md-6 col-12">
              <p>
                <b class="txt-prim title2">¿Quiénes somos?</b>
              </p>
              <p>
                En la que damos a conocer nuestra ubicación, la historia de la concesión, los financiamientos obtenidos y los valores que rigen a nuestro equipo.
              </p>
              <p>
                <b class="txt-prim title2">
                  Construcción, explotación, operación, conservación y mantenimiento del Viaducto Elevado Bicentenario
                </b>
              </p>
              <p>
                  Con una descripción de las principales acciones que el <b>VB</b> realiza para cumplir cabalmente con las obligaciones que le fueron otorgadas en el título de concesión para construir, operar y mantener la carretera en condiciones óptimas y seguras para nuestros usuarios.
              </p>
            </div>
            <div class="col-md-6 col-12">
              <p>
                <b class="txt-prim title2">Concesión Sostenible</b>
              </p>
                <p>Con información sobre las acciones que el <b>VB</b> realiza para contribuir con el desarrollo de su equipo, las comunidades y medio ambiente de zonas aledañas, así como las iniciativas para mantener la transparencia y buen gobierno de la concesión.</p>
              <p>
                <b class="txt-prim title2">Título de Concesión</b>
              </p>
              <p>
                Donde será posible encontrar el título de concesión e información de soporte (anexos y modificaciones).
              </p>
            </div>
            <div class="col-md-6 col-12">
            </div>
          </div>
        </div>

        <div class="container-left pt-0">
          <div class="row">
            <div class="col-12">

              <div class="mt-5">
                <h5 class="mb-5">
                  <b class="txt-prim title1">Resumen de Viaducto Bicentenario</b>
                </h5>
                <div class="row">
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/vb.png"' class="img-book img-shadow">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Resumen</small>
                    </p>
                    <a :href="inf" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>
                </div>
              </div>

              <div class="mt-5">
                <h5 class="mb-5">
                  <b class="txt-prim title1">Términos Clave VB</b>
                </h5>
                <div class="row">
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center">
                    <div>
                      <img :src='"../assets/img/emptyN.png"' class="img-book img-shadow">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Términos clave</small>
                    </p>
                    <a :href="termClave" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>
                </div>
              </div>
              <div class="mt-5">
                <h5 class="mb-5">
                  <b class="txt-prim title1">Título de Concesión</b>
                </h5>
                <div class="row">
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center">
                    <div>
                      <img :src='"../assets/img/TC-VB.png"' class="img-book img-shadow">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Título Concesión</small>
                    </p>
                    <a :href="titulo" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>
                </div>
              </div>

              <div class="mt-5">
                <h5 class="mb-5">
                  <b class="txt-prim title1">Anexos</b>
                </h5>
                <div class="row">
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/AN-VB.png"' class="img-shadow img-book">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Anexo 1</small>
                    </p>
                    <a :href="an1" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>
                  <!-- <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/AN-VB.png"' class="img-shadow img-book">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Anexo 2</small>
                    </p>
                    <a :href="an2" target="_blank" class="tag-dow">

                      Descargar
                    </a>
                  </div> -->
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/AN-VB.png"' class="img-shadow img-book">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Anexo 3</small>
                    </p>
                    <a :href="an3" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>
                  <!-- <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/AN-VB.png"' class="img-shadow img-book">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Anexo 4</small>
                    </p>
                    <a :href="an4" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div> -->
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/AN-VB.png"' class="img-shadow img-book">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Anexo 5</small>
                    </p>
                    <a :href="an5" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/AN-VB.png"' class="img-shadow img-book">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Anexo 6</small>
                    </p>
                    <a :href="an6" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/AN-VB.png"' class="img-shadow img-book">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Anexo 7</small>
                    </p>
                    <a :href="an7" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/AN-VB.png"' class="img-shadow img-book">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Anexo 8</small>
                    </p>
                    <a :href="an8" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/AN-VB.png"' class="img-shadow img-book">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Anexo 9</small>
                    </p>
                    <a :href="an9" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/AN-VB.png"' class="img-shadow img-book">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Anexo 10</small>
                    </p>
                    <a :href="an10" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/AN-VB.png"' class="img-shadow img-book">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Anexo 11</small>
                    </p>
                    <a :href="an11" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>



                  <!-- <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/AN-VB.png"' class="img-shadow img-book">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Transparencia VB - Anexo 7</small>
                    </p>
                    <a :href="a7" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/AN-VB.png"' class="img-shadow img-book">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Transparencia VB - Anexo 8</small>
                    </p>
                    <link rel="a" href="<%=  ${baseUrl} %> favicon.ico">
                    <a :href="a8" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/AN-VB.png"' class="img-shadow img-book">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Transparencia VB - Anexo 9</small>
                    </p>
                    <a :href="a9" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/AN-VB.png"' class="img-shadow img-book">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Transparencia VB - Anexo 10</small>
                    </p>
                    <a :href="a10" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/AN-VB.png"' class="img-shadow img-book">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Transparencia VB - Anexo 11</small>
                    </p>
                    <a :href="a11" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div> -->
                </div>
              </div>

              <div class="mt-5">
                <h5 class="mb-5">
                  <b class="txt-prim title1">Modificaciones al Título de Concesión y Otros</b>
                </h5>
                <div class="row">
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/A-VB.png"' class="img-book img-shadow">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Acuerdo</small>
                    </p>
                    <a :href="ac1" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/M-VB.png"' class="img-book img-shadow">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Tarifas</small>
                    </p>
                    <a :href="mod1" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>

                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/DT-VB.png"' class="img-book img-shadow">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Dictamen Técnico.</small>
                    </p>
                    <a :href="dictamen" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>

                    <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                        <div>
                            <img :src='"../assets/img/M-VB.png"' class="img-book img-shadow">
                        </div>
                        <p class="txt-prim text-center mb-0">
                            <small>Dictamen Técnico - Incremento de Tarifas</small>
                        </p>
                        <a :href="dictinc" target="_blank" class="tag-dow">
                            Descargar
                        </a>
                    </div>

                  <!-- <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/A-VB.png"' class="img-book img-shadow">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Acuerdo de Clasificación anexo 4.</small>
                    </p>
                    <p class="txt-prim text-center mb-0">
                      <small>Programa económico financiero</small>
                    </p>
                    <a :href="ac3" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div> -->

                  <!-- <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/A-VB.png"' class="img-book img-shadow">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Acuerdo de Clasificación 4</small>
                    </p>
                    <a :href="ac4" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div> -->
                </div>
              </div>

              <!-- <div class="mt-5">
                <h5 class="mb-5">
                  <b class="txt-prim title1">Modificación</b>
                </h5>
                <div class="row">

                </div>
              </div> -->

              <!-- <div class="mt-5">
                <h5 class="mb-5">
<<<<<<< HEAD
                  <b class="txt-prim title1">Fallo</b>
=======
                  <b class="txt-prim title1">Modificaciones al Título de Concesión y otros</b>
>>>>>>> 2b38aa9698a73992e826869276d702e45899937d
                </h5>
                <div class="row">
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/emptyN.png"' class="img-book img-shadow">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>Fallo</small>
                    </p>
                    <a :href="fall1" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>
                </div>
              </div>

              <div class="mt-5">
                <h5 class="mb-5">
                  <b class="txt-prim title1">Estados financieros</b>
                </h5>
                <div class="row">
                  <div class="col-md-3 col-6 d-flex justify-content-center flex-column align-items-center mb-5">
                    <div>
                      <img :src='"../assets/img/emptyN.png"' class="img-book img-shadow">
                    </div>
                    <p class="txt-prim text-center mb-0">
                      <small>VB en Estados Financieros Consolidados de ALEATICA</small>
                    </p>
                    <a :href="est" target="_blank" class="tag-dow">
                      Descargar
                    </a>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <contacto/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Contacto from './contact.vue'
  export default {
    components:{
      Contacto
    },

    data() {
      return {
        termClave: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/TERMINOS CLAVE VB1.pdf',
        inf: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/RESUMEN VB.pdf',
        titulo: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/TITULO DE CONSESION VEB.pdf',
        an1: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/ANEXO 1 Veb.pdf',
        an2: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/ANEXO 2 Veb.pdf',
        an3: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/ANEXO 3 Veb.pdf',
        an4: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/ANEXO 4 Veb.pdf',
        an5: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/ANEXO 5 Veb.pdf',
        an6: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/ANEXO 6 Veb.pdf',
        an7: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/ANEXO 7 Veb.pdf',
        an8: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/ANEXO 8 Veb.pdf',
        an9: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/ANEXO 9 Veb.pdf',
        an10: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/ANEXO 10 Veb.pdf',
        an11: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/ANEXO 11 Veb.pdf',
        ac1: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/ACUERDO Veb 2011.pdf',
        ac2: 'https://',
        ac3: 'https://',
        mod1: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/VB.PRIMERA.MODIFICACION.TITULO.CONCESION.ANEXO10.TARIFAS.PDF',
        fall1: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/VII.2.7. Fallo..pdf',
        est: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/VB en Estados Financieros Consolidados de ALEATICA.pdf',
        dictamen: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/Dictamen Tecnico Veb.pdf',
        dictinc: 'http://netsocialweb.com/aleatica/aleatica-docs/publicVB/Acuerdo Dictamen Tecnico - Incremento Tarifas.pdf'
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/viaducto.vue